import axios, {AxiosResponse} from "axios";
import {Config} from "./Config";

export function getConfig(): Promise<Config> {
  return axios.create().get('/api/config').then((response: AxiosResponse<Config>) => {
    return response.data;
  });
}
